module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer"
  }, [(_vm.item.attr === 'address') ? _c('v-address', {
    attrs: {
      "module": "invoice",
      "attrValue": _vm.form.address
    },
    on: {
      "change": _vm.addressSave
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0148d8f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/customer-express/index.vue
// module id = 1207
// module chunks = 82